import React from 'react';

const SignatureProgressStepper = ({ steps = [] }) => (
  <ol className="rg-signature-progress" aria-label="Progreso de firma">
    {steps.map((step) => (
      <li
        key={step.id}
        className={`rg-signature-progress__step rg-signature-progress__step--${step.state}`}
      >
        <span className="rg-signature-progress__marker" aria-hidden="true">
          {step.state === 'completed' ? (
            <i className="bi bi-check-lg"></i>
          ) : (
            <span>{step.index}</span>
          )}
        </span>
        <span className="rg-signature-progress__label">{step.label}</span>
      </li>
    ))}
  </ol>
);

export default SignatureProgressStepper;
